/* =============================================================
   sport-cinematic.js
   Femvie Sport landing — interactions
   · Language toggle (CZ/EN, persisted in localStorage)
   · Scroll reveal  (IntersectionObserver)
   · Animated stat counters
   · Segmented tab switcher
   · Smooth scroll for anchor links
   ============================================================= */
(function () {
  'use strict';

  /* ─── Language detection (follows Shopify site locale) ────── */
  // Read locale from <html lang="..."> set by Shopify (cs = Czech, en = English)
  var shopifyLang = (document.documentElement.lang || 'cs').toLowerCase();
  var isEn = shopifyLang === 'en' || shopifyLang.startsWith('en-');
  document.body.classList.toggle('lang-en', isEn);

  /* ─── Scroll reveal ──────────────────────────────────────── */
  var revealEls = document.querySelectorAll('.sp-reveal');

  if ('IntersectionObserver' in window && revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sp-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('sp-in'); });
  }

  /* ─── Stat counters ──────────────────────────────────────── */
  var counterEls = document.querySelectorAll('.sp-counter');

  function animateCounter(el) {
    var target = parseInt(el.dataset.target, 10);
    if (isNaN(target)) return;
    var duration = 1800;
    var startTime = null;

    function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      el.textContent = Math.round(easeOutQuart(progress) * target);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window && counterEls.length) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counterEls.forEach(function (el) { counterObserver.observe(el); });
  }

  /* ─── Segmented tabs ─────────────────────────────────────── */
  var tabBtns  = document.querySelectorAll('.sp-seg__tab');
  var tabPanels = document.querySelectorAll('.sp-seg__panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      tabBtns.forEach(function (b) {
        b.classList.toggle('sp-active', b.dataset.tab === target);
      });
      tabPanels.forEach(function (p) {
        p.classList.toggle('sp-active', p.dataset.tab === target);
      });
    });
  });

  /* ─── Smooth scroll anchor links ────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = anchor.getAttribute('href');
      if (id === '#') return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        var offset = 80; /* nav height clearance */
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

})();
